import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from '../PracticalInformation/Item'

export function SkiPass() {
  const ski = useCMSPageField('PDP.SkiAncillaries')
  const intl = useIntl()

  const introduction = ski?.skiPass?.introduction
  const extraInfo = ski?.skiPass?.extraInfo

  if (!introduction && !extraInfo)
    return null

  return (
    <Item elementDL="Ski pass" title={intl.formatMessage({ id: 'ski_ancillaries_ski_pass_title' })} Glyph="SkiPass">
      {introduction && <RichText innerHTML={introduction} />}
      {extraInfo && <RichText innerHTML={extraInfo} />}
    </Item>
  )
}
